export default __webpack_public_path__ + "static/media/Term_of_Service.b2a68741.pdf";